import { TableRow, TableCell } from '@mui/material';
import { getNumberComma } from '../../utils/numberUtils';
import SalesManageStaticsTableCell from './SalesManageStaticsTableCell';

const SalesManageStaticsTeamRow = ({ data, headerRows }) => {
  if (!headerRows || !data) {
    return null;
  }

  return (
    data &&
    data.map((hq, hIndex) => {
      return hq?.children.map((dp, dpIndex) => {
        return dp?.children.map((team, tIndex) => {
          return team?.children.map((emp, empIndex) => (
            <TableRow key={`${hIndex}_${dpIndex}_${tIndex}_${empIndex}`}>
              {dpIndex === 0 && tIndex === 0 && empIndex === 0 && (
                <TableCell
                  rowSpan={hq.rowSpan}
                  sx={{ width: '100px' }}
                  colSpan={hq?.id === 'total' ? '4' : '1'}
                >
                  {hq.name}
                </TableCell>
              )}
              {tIndex === 0 &&
                empIndex === 0 &&
                hq?.id !== 'total' &&
                dp?.id !== 'total' &&
                team?.id !== 'total' &&
                emp?.id !== 'total' && (
                  <TableCell
                    rowSpan={dp.rowSpan}
                    sx={{ width: '200px' }}
                    colSpan={dp?.id === 'subtotal' ? 3 : 1}
                  >
                    {dp.name}
                  </TableCell>
                )}

              {empIndex === 0 &&
                hq?.id !== 'total' &&
                dp?.id !== 'total' &&
                team?.id !== 'total' &&
                emp?.id !== 'total' &&
                dp?.id !== 'subtotal' && (
                  <TableCell rowSpan={team.rowSpan} sx={{ width: '200px' }}>
                    {team.name}
                  </TableCell>
                )}

              {hq?.id !== 'total' &&
                dp?.id !== 'total' &&
                team?.id !== 'total' &&
                emp?.id !== 'total' &&
                dp?.id !== 'subtotal' &&
                emp?.name !== team?.name && (
                  <TableCell sx={{ width: '300px' }}>{emp.name}</TableCell>
                )}
              <TableCell sx={{ width: '100px' }} align="right" padding="none">
                {getNumberComma(emp?.yearBudget)}
              </TableCell>
              <SalesManageStaticsTableCell
                data={emp?.data}
                headerRows={headerRows}
              />
            </TableRow>
          ));
        });
      });
    })
  );
};

export default SalesManageStaticsTeamRow;
